var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"text-white d-flex justify-content-center align-items-center",class:`${_vm.background} icon-container`},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }